//import react
import React, {Component} from 'react';
//import admin-on-rest lib resources
import { Admin, Resource } from 'admin-on-rest';
//import custom auth & rest client
import authClient from './authClient';
import restClient from './restClient';
import Menu from './Menu';

import translations from './i18n';

//import Material UI
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  cyan500, grey100, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

//App sections : Dashboard
import { Dashboard } from './dashboard';
import { AdsList, AdsSiteSelectorPage } from './ads/Ads';
import { EditDetails } from './member/Member';

import CogIcon from 'material-ui/svg-icons/content/create';
import routes from './routes';
import Login from './login';

import authAddonSaga from './saga/authAddonSaga.js'

//Custom theme https://github.com/mui-org/material-ui/blob/master/src/styles/getMuiTheme.js
/*
* MAIN BUTTONS:  raisedButton: { textTransform: 'none',primaryColor:'#284263' }
* BUTTONS RIGHT TOP DETAIL PAGES: flatButton: { textTransform: 'none', primaryColor:'#284263', color: '#284263', backgroundColor: '#fd9512', background: '#fd9512'  },
* APPBAR: appBar: { color: '#284263' }, 
*/

//snackbar color (shonotifciations) kan zijn: niks (kleur wordt error, rood), warning (kleur wordt oranje accent1color), confirm (kleur wordt blauw primary1color)

const CloudhintsTheme = {
    spacing: spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
      primary1Color: '#284263',
      primary2Color: '#284263',
      primary3Color: grey400,
      accent1Color: '#fd9512',
      accent2Color: grey100,
      accent3Color: grey500,
      textColor: darkBlack,
      alternateTextColor: white,
      canvasColor: white,
      borderColor: grey300,
      disabledColor: fade(darkBlack, 0.3),
      pickerHeaderColor: cyan500,
      clockCircleColor: fade(darkBlack, 0.07),
      shadowColor: fullBlack,
    },
	datePicker: {
		headerColor: '#284263',	
	},
	card: {	 borderColor: '#fd9512' },
	button: { margin: '0' },
	raisedButton: { textTransform: 'none',primaryColor:'#fd9512', margin: '0', spacing: '0' },
	flatButton: { textColor:'#fd9512', primaryTextColor:'#fd9512',  textTransform: 'none' },
	snackbar: {
      textColor: '#fff',
      backgroundColor: '#284263',
      actionColor: '#fff',
    },
};

class App extends Component {
    render() {
        return (
            <Admin
				customSagas={[authAddonSaga]}
				loginPage={Login}
				theme={getMuiTheme(CloudhintsTheme)}
                title="Cloudhints portal"
				customRoutes={routes}
                restClient={restClient}			
                authClient={authClient}  
				dashboard={Dashboard}
                messages={translations}
                menu={Menu}
				locale='nl'
				>	
			   <Resource name="member/ads" options={{label:'Advertenties'}} list={AdsList} create={AdsSiteSelectorPage} icon={CogIcon} />
			   <Resource name="userauth/details" edit={EditDetails} />
			   
            </Admin>
        );
    }
}

export default App;






// WEBPACK FOOTER //
// ./src/App.js